import PackageJSON from '../../../package.json';
export const envResolver = {
	API_BASE_URL: import.meta.env.VITE_API_BASE_URL ?? 'https://api3.pineye.io',
	SOCKET_BASE_URL: import.meta.env.VITE_SOCKET_BASE_URL ?? 'https://wss.pineye.io',
	MODE: import.meta.env.VITE_MODE ?? 'PRODUCTION',
	VERSION: PackageJSON.version,
	TON_MANIFEST: import.meta.env.VITE_TON_MANIFEST ?? 'https://app.pineye.io/tonconnect-manifest.json',
};
